<style>
	.bgs {
		background-color: #f3f7f8;width:100%; 
	}
.home_left{width:35vw;height:42vw;background-color:#fff;border-radius:.5vw;
 float:left;margin-top:5vw;margin-left:14vw;cursor:pointer;}
.home_left img{display:block;width:8vw;margin-top:15vw;}
.home_left button{display:block;margin:0 auto;border:0;background:#3465ff;
        outline:none;color:#fff;height:4vw;line-height:4vw;font-size:1.4vw;
		padding:0 3vw;border-radius:.2vw;margin-top:2vw;}
.home_right{width:35vw;float:right;height:42vw;margin-top:5vw;
           margin-right:14vw;cursor:pointer;}
.right_top{margin:0;padding:0;overflow:hidden;width:100%;height:20vw;background:#fff;border-radius:.5vw;}
.right_top img{display:block;width:8vw;margin-top:3vw;}
.right_top button{display:block;margin:0 auto;border:0;background:none;
        outline:none;color:#000;height:4vw;line-height:4vw;font-size:1.6vw;
		padding:0 3vw;border-radius:.2vw;margin-top:0;}
.right_bottom{width:100%;height:21.2vw;margin-top:.8vw;}
.bottom_left{background:#fff;border-radius:.5vw;width:17vw;height:100%;float:left;}
.bottom_right{float:right;}
.right_bottom img{display:block;width:8vw;margin-top:3vw;}
.right_bottom button{display:block;margin:0 auto;border:0;background:none;
        outline:none;color:#000;height:4vw;line-height:4vw;font-size:1.6vw;
		padding:0 3vw;border-radius:.2vw;margin-top:0;}
.copyright{width:95vw;margin:0 auto;height:10vw; padding:0;overflow:hidden;}
.copyright span{display:block;width:30vw;line-height:10vw;font-size:1.2vw;
  }
.copyright span.cp1{float:left;text-align:left;}
.copyright span.cp2{float:right;text-align:right;}

.u_center{width:5.4vw;height:10vw;background:#fff;position:fixed;
right:1vw;top:1vw;border-radius:5.4vw;overflow:hidden;
box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.33);z-index:99999;
-webkit-box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.33);
-moz-box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.33);
}
.u_center img{width:4vw;height:4vw;display:block;margin:0 auto; 
   margin-top:.7vw;}
.u_center span{display:block;text-align:center;line-height:2vw;
font-size:1.2vw;width:4vw;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;}
.block2 {
  z-index: 27;
  width: 12px;
  height: 7px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngc3e515649bae42931812283942a5d9b46660b544ef0e1d3611d4f766324183dd)
    100% no-repeat;
  align-self: center;
  margin-top: 5px;
}
.u_center:hover{
height:20vw;
}
.u_center ul{height:12vw;}
.u_center ul li{width:5.4vw;height:3vw; padding:.5vw 0;}
.u_center ul li img{width:2vw;height:2vw;margin-top:.5vw;display:block;}
.u_center ul li:hover{box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.33);
-webkit-box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.33);
-moz-box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.33);}


.jt{width:2vw;height:2vw;}
.jt img{width:2vw;height:2vw;margin-top:0;}

.lasts{ height:4vw;background:#fff;position:fixed;z-index:99999;
  top:17.7vw;right:6.3vw;padding:0 2vw;line-height:4vw;font-size:1.2vw;
box-shadow: -10px 0px  9px 0px rgba(0,0,0,0.13);
-webkit-box-shadow: -10px 0px  9px 0px rgba(0,0,0,0.13);
-moz-box-shadow: -10px 0px  9px 0px rgba(0,0,0,0.13);
border-top-left-radius:.5vw;border-bottom-left-radius:.5vw;
}


.expireds{ height:4vw;background:#fff;position:fixed;z-index:99999;
  top:13.7vw;right:6.3vw;padding:0 2vw;line-height:4vw;font-size:1.2vw;
box-shadow: -10px 0px  9px 0px rgba(0,0,0,0.13);
-webkit-box-shadow: -10px 0px  9px 0px rgba(0,0,0,0.13);
-moz-box-shadow: -10px 0px  9px 0px rgba(0,0,0,0.13);
border-top-left-radius:.5vw;border-bottom-left-radius:.5vw;
}
.ucs{ height:4vw;background:#fff;position:fixed;z-index:99999;
  top:9.7vw;right:6.3vw;padding:0 2vw;line-height:4vw;font-size:1.2vw;
box-shadow: -10px 0px  9px 0px rgba(0,0,0,0.13);
-webkit-box-shadow: -10px 0px  9px 0px rgba(0,0,0,0.13);
-moz-box-shadow: -10px 0px  9px 0px rgba(0,0,0,0.13);
border-top-left-radius:.5vw;border-bottom-left-radius:.5vw;
}
.logs{ height:4vw;background:#fff;position:fixed;z-index:99999;
  top:21.7vw;right:6.3vw;padding:0 2vw;line-height:4vw;font-size:1.2vw;
box-shadow: -10px 0px  9px 0px rgba(0,0,0,0.13);
-webkit-box-shadow: -10px 0px  9px 0px rgba(0,0,0,0.13);
-moz-box-shadow: -10px 0px  9px 0px rgba(0,0,0,0.13);
border-top-left-radius:.5vw;border-bottom-left-radius:.5vw;
}




.draw-enter-active, .draw-leave-active {
     transition: opacity 1s;
}
.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
     opacity: 0;
}
.mengban{width:100vw;height:100vh;position:fixed;top:0;z-index:999;
background:url(../assets/images/yao_bg4.png) repeat;}
.login_box{width:38vw;height:30.5vw;background:#fff;position:fixed;top:15vh;
z-index:999;left:32.5vw;border-radius:1vw;}
.login_head{width:100%;height:5vw;border-bottom:#e6e6e6 solid 1px;}
.blank{width:30%;float:left;height:6vw;}
.title{width:40%;float:left;line-height:6vw;font-size:2vw;text-align:center}
.cha{width:20%;float:right;height:5vw;margin-right:5%;}
.cha img{width:2vw;height:2vw;margin-top:2vw;display:block;float:right;}

.login_method{width:28vw;height:3.6vw;margin:0 auto;margin-top:1vw;
}
.method{width:14vw;background:#eee;height:3.6vw;float:left;line-height:3.6vw;
    color:#000;font-size:1.2vw;text-align:center;cursor:pointer;}
.login_area{margin:0 auto;padding:0;overflow:hidden;width:28vw;height:14.4vw; }
.login_line{margin:0;padding:0;overflow:hidden;width:99%;height:3.6vw;border:#DDD solid 1px;position:relative;
border-radius:.6vw;margin-top:.8vw;}
.login_line input{display:block;width:90%;height:3.6vw;border:0;outline:none;
position:absolute;top:0;left:3vw;font-size:1.2vw;color:#000;}
.login_line input::placeholder{font-size:1.2vw;color:#ccc;}
.login_line img{width:1.8vw;top:0.9vw;position:absolute;left:.5vw;}


.login_line input.yzms{width:20vw;}
.capa{width:11vw;float:right;height:4vw;margin-top:1vw;
border-radius:1vw;overflow:hidden;}
.capa img{width:100%;height:100%;}
.btn{width:32vw;height:4vw;background:#3465ff;line-height:4vw;color:#fff;
font-size:1.6vw;text-align:center;border-radius:1vw;cursor:pointer;

 -webkit-touch-callout:none; /*系统默认菜单被禁用*/
 -webkit-user-select:none; /*webkit浏览器*/
 -khtml-user-select:none; /*早期浏览器*/
 -moz-user-select:none;/*火狐*/
 -ms-user-select:none; /*IE10*/
 user-select:none; 
 
}


.login_line button{display:block;position:absolute;right:0; font-size:1.2vw;
  line-height:3.6vw;right:2vw;color:#3465ff;background:none;border:0;outline:none;}
  
  
.yzm{margin:0;padding:0;overflow:hidden;width:19vw;height:3.6vw;border:#DDD solid 1px;position:relative;
border-radius:.6vw;margin-top:.8vw;float:left;}

.yzm input{display:block;width:14vw;height:3.6vw;border:0;outline:none;
position:absolute;top:0;left:3vw;font-size:1.2vw;color:#000;}
.yzm input::placeholder{font-size:1.2vw;color:#ccc;width:14vw;}
.yzm img{width:1.8vw;top:0.9vw;position:absolute;left:0.5vw;}
.yzm input.yzms{width:16vw;}
.capa{width:8vw;float:right;height:3.6vw;margin-top:.8vw;
border-radius:.6vw;overflow:hidden;}
.capa img{width:100%;height:100%;}
.btn{width:28vw;height:3.6vw;background:#3465ff;line-height:3.6vw;color:#fff;
font-size:1.5vw;text-align:center;border-radius:.6vw;}




.yzm button{display:block;position:absolute;right:0; font-size:1.4vw;
  line-height:4vw;right:2vw;color:#3465ff;background:none;border:0;outline:none;}
</style>
<template>
	<div class="bgs">
	    <transition name="draw">
			 <div class="mengban" v-show="login"></div>
	    </transition>
		<transition name="draw">
			 <div class="login_box" v-show="login">
			   <div class="login_head">
				  <div class="blank"></div>
				  <div class="title">系统登录</div>
				  <div @click="cha()" class="cha"><img src="../assets/images/cha.png"></div>
			   </div>
			   <div class="login_method">
				  <div @click="method(1)" class="method" :style="way1">账号密码登录</div>
				  <div @click="method(2)" class="method" :style="way2">手机号登录</div>
			   </div>
			   <div v-if="way==1">
				   <div class="login_area">
				   <div style="clear:both;"></div>
					   <div class="login_line">
						  <img src="../assets/images/user1.png">
						  <input  type="text" placeholder="请输入账号" v-model="username">
					   </div>
					   <div class="login_line">
						  <img src="../assets/images/user2.png">
						  <input  type="password" placeholder="请输入密码" v-model="password">
					   </div>
					   <div class="yzm">
						  <img src="../assets/images/user3.png">
						  <input @keyup.enter="do_login()" class="yzms" type="text" placeholder="请输入验证码" v-model="verify">
					   </div>
					   <div class="capa" @click="refresh_yzm()">
						 <img :src="yzm">
					   </div>
				   </div>
				   <div class="btn"  @click="do_login()">登录</div>
			   </div>
			   <div v-else>
				   <div class="login_area" style="height:14.4vw; ">
				       <div style="clear:both;"></div>
					   <div class="login_line" style="margin-top:2.6vw;">
						  <img src="../assets/images/user4.png">
						  <input  type="text" placeholder="请输入手机号" v-model="phone">
					   </div>
					    
					   <div class="login_line">
						  <img src="../assets/images/user3.png">
						  <input @keyup.enter="do_login()" class="yzms" type="text" placeholder="请输入验证码" v-model="code">
					      <!--<span id="send" @click="send()">获取验证码</span>-->
						  <button id="send" @click="send()">获取验证码</button>
					   </div>
					   
				   </div>
				   <div class="btn" @click="do_login()">登录</div>
			   </div>
			   
			 </div>
		 </transition>
	     <div class="u_center"  @click="more()"  :style="active">
		    <img  @click="login_box()" :src="head" style="border-radius: 4vw;">
			<span>{{nickname}}</span>
			<div class="jt">
			  <img src="../assets/images/up.png" v-if="u_menu">
			  <img src="../assets/images/down.png" v-else>
			</div>
			<ul v-show="u_menu">
			     <li  @mouseover="mouseOver(1)"  @mouseleave="mouseLeave(1)" @click="my()">
				    <img v-if="m1_on" src="../assets/images/my11.png">
					<img v-else src="../assets/images/my1.png">
				 </li>
			     <li  @mouseover="mouseOver(2)"  @mouseleave="mouseLeave(2)" >
				    <img v-if="m2_on" src="../assets/images/my22.png">
					<img v-else src="../assets/images/my2.png">
				 </li>
			     <li @mouseover="mouseOver(3)"  @mouseleave="mouseLeave(3)" >
				    <img v-if="m3_on" src="../assets/images/my33.png">
					<img v-else src="../assets/images/my3.png">
				 </li>
				 <li @mouseover="mouseOver(4)"  @mouseleave="mouseLeave(4)" @click="logout()">
				    <img v-if="m4_on" src="../assets/images/my44.png">
					<img v-else src="../assets/images/my4.png">
				 </li>
			</ul>
		 </div>
		  <transition name="draw">
		      <div class="lasts" v-show="shenggyu">剩余{{balance}}条</div>
		  </transition>
		  <transition name="draw">
		      <div class="expireds" v-show="daoqi">{{exp|formatDate}} 到期</div>
		  </transition>
		  <transition name="draw">
		      <div class="ucs" v-show="ucs_show">用户中心</div>
		  </transition>
		  <transition name="draw">
		      <div class="logs" v-show="logout_show">退出登录</div>
		  </transition>
		  
		  
	</div>
</template>
<script>
	 
	export default {
	 
		data() {
			return {
				active:"height:10vw;" ,
				u_menu:false,
				m1_on:false,
				m2_on:false,
				m3_on:false,
				m4_on:false,
				shenggyu:false,
				way:1,
				ucs_show:false,
				logout_show:false,
				daoqi:false,
				way1:"background:#3465ff;color:#fff;",
				way2:"",
				login:false,
				token:"",
				username:"",
				nickname:"请登录",
				password:"",
				phone:"",
				verify:"",
				code:"",
				yzm:"",
				rand:"",
                login_token:"",	
                head:"https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/head.png",
                loged:false,
                balance:"0",
                exp:"",				
			}
		},props:["logins"],
		mounted() {
		      let self=this;
		      
			  var token= localStorage.getItem("token");
			  if(!token){
					 // self.$router.push("/login"); 
			  }else{
			      var head=localStorage.getItem("head");	
			      if(head){
				    this.head=head;
				  }
			      var nickname=localStorage.getItem("nickname");
				  if(nickname){
				    this.nickname=nickname;
				  }
			      self.token=token;
				  self.try_login();
				  self.get_user_info();
			  } 
			 this.MathRand();
             this.yzm= this.$api+'/home/verify/rand/'+this.rand; 
			 
			 
			
		},filters: {
				formatDate: function(value) {
					var date = new Date();
					 date.setTime(value*1000);
					var month = date.getMonth() + 1;
					var hours = date.getHours();
					if (hours < 10)
						hours = "0" + hours;
					var minutes = date.getMinutes();
					if (minutes < 10)
						minutes = "0" + minutes;
					var time = date.getFullYear() + "-" + month + "-" + date.getDate()  ;
					return time;
				}
			},
		methods: {
			my(){
			  this.$router.push("/my"); 
			}, try_login() { 
				let self=this;
				  axios.post(this.$api+'/home/try_login', {
						   token: self.token
				  }).then(function (response) {  				
					  let data=response.data;
					  if(data.state==2){
						   localStorage.setItem("token","");        	
					  }else if(data.state==1){
						         self.get_user_info();
                     self.login=false;	
                     self.loged=true;	    	
					  }	 
				  }).catch(function (error) {
						   
				  });
			},
			 send() {
				let self=this;
				if (!this.phone) {
				   this.$toast.center('请输入手机号');
				   return;
				}else{
					   
					  axios.post(this.$api+'/home/chk_phone', {
							   phone: self.phone
					  }).then(function (response) {  
					
						   let data=response.data;
						   
						  if(data.state==1){
							    self.login_token=data.data;
								self.sendcode()            	
						  }else{
							 self.$toast.center(data.msg);
						  }
							 
					  }).catch(function (error) {
							   
					  });
				  
				  }
			},sendcode(){
							  let self=this;
							  var phone=this.phone;
		                            axios.post(this.$api+'/home/send_code', {
								       phone: phone,
									   token: self.login_token
						              }).then(function (response) {  
					
							          let data=response.data;
								 
									  if(data.state==1){
									  
										 var countdown=60; 
										 function settime(){    

                                                                                   if (countdown > 0) {
                                                                                                 document.getElementById("send").setAttribute("disabled",true);
																				                
                                                                                                 document.getElementById("send").innerHTML = "重新发送"+countdown;
                                                                                                  countdown--; 

                                                                                     } else if(countdown == 0)   { 

																								 countdown=null;
                                                                                                 document.getElementById("send").setAttribute("disabled",false);
																				                
                                                                                                 document.getElementById("send").innerHTML = "发送验证码";
                                                                                                 return ;

                                                                                     } else{

																											 return;

																						  }

																								 

		                                  }
										 	setInterval(function() { settime() },1000) 	 
									  }else{
										 self.$toast.center(data.msg);
									  }
								 
								  }).catch(function (error) {
										   
								  });
		},
			MathRand(){
			 for(var i=0;i<8;i++)
				{
				this.rand+=Math.floor(Math.random()*10);
				}
			 },
		   refresh_yzm(){
		     var time = new Date().getTime(); 
        
		     this.yzm= this.$api+'/home/verify/rand/'+this.rand+'/time/'+time; 
		   },
		   do_login(){	 
 	   
		      let self=this;
		      axios.post(this.$api+'/home/login', {
			           username:self.username,
					   password:self.password,
					   phone:self.phone,
					   verify:self.verify,
					   code:self.code,
					   method:self.way,
					   rand:self.rand
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					 localStorage.setItem(
							  "token",data.data
                     );					 
                     self.token=data.data;				 
					 self.get_user_info();
                     self.$toast.center('登录成功');
                     self.login=false;	
                     self.loged=true;					 
				  }else{
				     self.$toast.center(data.msg);
				  }
		      }).catch(function (error) {
			         
		      });
		  },
		  get_user_info(){	        
		      let self=this;
		      axios.post(this.$api+'/home/get_user_info', {
					   token:self.token
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					 self.head=data.data.img; 
					 localStorage.setItem(
							  "head",data.data.img
                     );
                     localStorage.setItem(
							  "nickname",data.data.username
                     );					 
                     self.nickname=data.data.username;
                     self.loged=true;
                     self.balance=data.data.balance;
                     self.exp=data.data.end_time;					 
				  } 
		      }).catch(function (error) {
			         
		      });
		  },
		   more(){
		         if(!this.loged){
				    this.login=true;
				    return;
				 }
				 this.u_menu=!this.u_menu;
				 if(this.u_menu==true){
				    this.active="height:27vw;" ;
				 }else{
				    this.active="height:10vw;" ;
				 }
		   },login_box(){
		       if(!this.loged){
				   this.login=true;
			   }
		   },cha(){
		       this.login=false;
		   },
		   method(val){
		        this.way=val;
		      if(val==1){
			    this.way1="background:#3465ff;color:#fff;";
				this.way2="";
			  }else{
			    this.way2="background:#3465ff;color:#fff;";
				this.way1="";
			  }
		   },
		   mouseOver(val) {
			   if(val==1){
			     this.m1_on=true;
				 this.ucs_show=true;
			   }else if(val==2){
			     this.m2_on=true;
				 this.daoqi=true;
			   }else if(val==3){
			     this.m3_on=true;
				 this.shenggyu=true;
			   }else if(val==4){
			     this.m4_on=true;
				 this.logout_show=true;
			   }
		   },mouseLeave(val) {
               if(val==1){
			     this.m1_on=false;
				 this.ucs_show=false;
			   }else if(val==2){
			     this.m2_on=false;
				 this.daoqi=false;
			   }else if(val==3){
			     this.m3_on=false;
				 this.shenggyu=false;
			   }else if(val==4){
			     this.m4_on=false;
				 this.logout_show=false;
			   }
           },logout(){	        
		             localStorage.setItem(
							  "token",""
                     );	
					 this.head="https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/head.png";
					 this.loged=false;
					 this.nickname="请登录";
					 this.balance=0;
					 let self=this;
					  setTimeout(function(){
								        self.$router.push("/");  
					  },2000);
					 
		  },
		},watch:{
			 logins(val){
			   if(val){
			      this.login=true;
			   } 
			 },login(val){
			    if(!val){
				   this.$emit("logins", false);
				}
			 }
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/u_center.vue